import { Component } from '@angular/core';
import { CoreService } from '@doc/core';

@Component({
  selector: 'doc-backoffice-view-mode',
  templateUrl: './backoffice-view-mode.component.html',
  styleUrls: ['./backoffice-view-mode.component.scss'],
  standalone: false,
})
export class BackofficeViewModeComponent {

  viewMode = 'list';
  constructor(private coreService:CoreService){
    this.coreService.viewMode.subscribe(x=>this.viewMode=x);
  }
  onViewModeChange(mode:string){
    this.viewMode = mode;
    localStorage.setItem('defaultView',this.viewMode);
    this.coreService.changeViewMode(this.viewMode);
  }
}
